import { render } from "./FormBuilderIndex.vue?vue&type=template&id=7e7a0cb6&scoped=true&ts=true"
import script from "./FormBuilderIndex.vue?vue&type=script&lang=ts"
export * from "./FormBuilderIndex.vue?vue&type=script&lang=ts"

import "./FormBuilderIndex.vue?vue&type=style&index=0&id=7e7a0cb6&lang=scss"
import "./FormBuilderIndex.vue?vue&type=style&index=1&id=7e7a0cb6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e7a0cb6"]])

export default __exports__